import { isEmpty } from 'lodash'

// Mirrors the Salesforce formula field `Order_Status_Grouped__c`, which is a
// calculated field and so cannot be synced through Heroku Connect:
//
//   IF(NOT(ISBLANK(TEXT(Order_Sub_Status__c))),
//      TEXT(Order_Status__c) & " : " & TEXT(Order_Sub_Status__c),
//      TEXT(Order_Status__c))
//
// Returns undefined when there is no status so callers can fall back.
export default function formatOrderStatusGrouped({
  orderStatus,
  orderSubStatus,
}) {
  if (isEmpty(orderStatus)) return
  if (isEmpty(orderSubStatus)) return orderStatus

  return `${orderStatus} : ${orderSubStatus}`
}
